module.exports = "/_next/static/images/3c7af0824719f5ecb030473908fa8523-pay-yourself-lg@1x.jpg";